import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import dotenv from 'dotenv';
import { Provider } from 'react-redux';
import store from './store';
import AppProvider from './AppProvider';
import { getAxiosBaseUrl } from './lib/util';

dotenv.config();
axios.defaults.baseURL = getAxiosBaseUrl();
axios.defaults.withCredentials = true;
console.info(`%c
 ██████╗ █████╗ ███╗   ██╗██████╗ 
██╔════╝██╔══██╗████╗  ██║██╔══██╗
██║     ███████║██╔██╗ ██║██████╔╝
██║     ██╔══██║██║╚██╗██║██╔══██╗
╚██████╗██║  ██║██║ ╚████║██████╔╝
 ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═════╝ `,
"color:#bc216d")

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <AppProvider />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
);
